<template>
  <div class="animate__animated animate__fadeIn">
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Novo Grupo") }}</h1>

    <form @submit.prevent="submit" ref="addItem">
      <div class="row">
        <form-input
          v-model="item.nome_grupo"
          grid="6"
          label="Nome do Grupo"
          :required="true"
        />
        <form-select
          v-model="item.faixa_etaria"
          grid="6"
          label="Faixa Etária"
          :itens="$root.arrays.scfv_faixa_etaria"
          :required="true"
        />
        <form-select
          v-model="item.acesso"
          grid="3"
          label="Acesso"
          :itens="$root.arrays.scfv_acesso"
        />
        <form-select
          v-model="item.periodicidade"
          grid="3"
          label="Periodicidade"
          :itens="$root.arrays.scfv_periodicidade"
          :required="true"
        />

        <form-select
          v-model="item.dias_semana"
          grid="6"
          label="Dia(s) da Semana"
          :itens="$root.arrays.scfv_dias_semana"
          :required="true"
          :multiple="true"
        />

        <form-calendar v-model="format_hora" grid="2" label="Horário" mode="time" />
        <form-input
          v-model="item.numero_vagas"
          type="number"
          grid="2"
          label="Vagas"
          :required="true"
          :min="3"
          ajuda="O número de vagas deve ser no mínimo 3"
        />

        <form-input
          v-model="item.carga_horaria"
          type="number"
          grid="2"
          label="Carga Horária"
          :required="true"
          :min="1"
        />

        <form-select
          v-model="item.carater"
          grid="3"
          label="Caráter"
          :itens="$root.arrays.scfv_carater"
        />

        <form-select
          v-model="item.forma_execucao"
          grid="3"
          label="Forma de Execução"
          :itens="$root.arrays.scfv_execucao"
          @change="formaExecucao"
        />

        <form-select
          v-model="item.unidade_osc_id"
          grid="12"
          label="Selecione uma OSC"
          :itens="unidades"
          v-if="campoExtra == true"
        />

        <form-select
          v-model="item.unidade_base_id"
          grid="6"
          label="Base Física das Atividades"
          :itens="unidades"
          :required="true"
        />

        <form-select
          v-model="item.tecnico_id"
          grid="6"
          label="Técnico de Referência"
          :itens="listtecnicos"
          :required="true"
          :loading="loadingTecnicos"
          :disabled="loadingTecnicos"
        />

        <form-select
          v-model="item.orientador_id"
          grid="6"
          label="Orientador Social"
          :itens="listtecnicos"
          :required="true"
          :loading="loadingTecnicos"
          :disabled="loadingTecnicos"
        />

        <form-select
          v-model="item.facilitador_id"
          grid="6"
          label="Facilitador de Oficinas"
          :itens="listtecnicos"
          :loading="loadingTecnicos"
          :disabled="loadingTecnicos"
        />
        <label class="d-block font-weight-bold pl-3 mt-2"
          >Selecione o(s) técnico(s) participante(s)</label
        >
      </div>
      <search-tecnico-grupo
        :grupo-id="item.id || null"
        :tecnicos.sync="item.tecnicos"
        col="6"
      />
      <div class="row">
        <form-textarea-editor
          v-model="item.observacoes"
          label="Objetivos"
          :required="true"
        />

        <form-file
          @submit="submitFile"
          multiple
          btn-text="Iniciar"
          :progress="progressCompleted"
        />
      </div>
      <div class="row pt-4 px-0 d-flex justify-content-end">
        <div class="col-auto px-2 text-right">
          <a class="btn btn-default" @click="$emit('voltar')">
            <i class="mdi mdi-arrow-left" />
          </a>
          <button class="btn btn-success btn-submit" data-style="zoom-in" type="submit" :disabled="saving">
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { misMixins } from "./mixins.js";
import SearchTecnicoGrupo from "./SearchTecnicoGrupo.vue";
function normalizarTecnicos(valor) {
  if (valor === null || valor === undefined || valor === "") {
    return [];
  }

  if (Array.isArray(valor)) {
    return valor.slice();
  }

  if (typeof valor === "string") {
    try {
      const tecnicos = JSON.parse(valor);
      if (Array.isArray(tecnicos)) {
        return tecnicos;
      }
    } catch (error) {
      // Um formato inválido deve ser informado, sem apagar a seleção existente.
    }
  }

  throw new Error("A lista de técnicos participantes está em formato inválido.");
}

function mensagemErro(error, padrao) {
  const dados = error && error.response && error.response.data;
  if (dados && dados.errors && typeof dados.errors === "object") {
    const mensagens = Object.keys(dados.errors)
      .reduce((lista, campo) => lista.concat(dados.errors[campo]), [])
      .filter((mensagem) => typeof mensagem === "string");
    if (mensagens.length > 0) {
      return mensagens.join("\n");
    }
  }

  if (dados && typeof dados.message === "string") {
    return dados.message;
  }

  return error && error.message ? error.message : padrao;
}

export default {
  name: "Add",

  components: {
    SearchTecnicoGrupo,
  },

  data() {
    return {
      item: {
        numero_vagas: 3,
        tecnicos: [],
      },
      campoExtra: false,
      saving: false,
      files: [],
      progressCompleted: 0,
      tecnicos: [],
      unidades: [],
      loadingTecnicos: true,
      format_hora: "",
    };
  },
  mixins: [misMixins],
  methods: {
    getItem() {},
    formaExecucao() {
      if (this.item.forma_execucao == 2) {
        this.campoExtra = true;
      } else {
        this.campoExtra = false;
      }
    },
    submitFile(files) {
      this.files = files;
    },
    submit() {
      if (this.saving) {
        return;
      }

      let formData;
      try {
        const tecnicos = normalizarTecnicos(this.item.tecnicos);
        this.item.horario = this.format_hora != "" ? this.format_hora : "";
        formData = new FormData();

        if (this.files && this.files.length > 0) {
          for (const i of Object.keys(this.files)) {
            formData.append("anexos[]", this.files[i]);
          }
        }

        for (const key of Object.keys(this.item)) {
          if (key !== "tecnicos" && key !== "tecnicos_contexto") {
            formData.append(key, this.item[key]);
          }
        }
        formData.append("tecnicos", JSON.stringify(tecnicos));
      } catch (error) {
        swal.fire({
          title: "Ops!",
          text: mensagemErro(error, "Não foi possível preparar o cadastro do grupo."),
          icon: "error",
        });
        return;
      }

      this.saving = true;
      const ladda = Ladda.create(this.$el.querySelector(".btn-submit"));
      ladda.start();

      return axios
        .post(`api/dashboard/scfv`, formData, {
          onUploadProgress: (event) => {
            this.progressCompleted = event.total
              ? Math.round((event.loaded * 100) / event.total)
              : 0;
          },
        })
        .then((response) => {
          this.files = [];
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.$router.push(`/dashboard/scfv/edit/${response.data.data.id}`);
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            text: mensagemErro(error, "Não foi possível salvar o grupo."),
            icon: "error",
          });
        })
        .finally(() => {
          ladda.stop();
          this.saving = false;
          this.progressCompleted = 0;
        });
    },
  },
};
</script>
